module.exports = __webpack_public_path__ + "img/logo2.a9ad1614.jpeg";